import {
  DataSources,
  ExternalAccount,
  ImportedData,
  OtherData,
  OutcomeReasons,
  ReasonCodes,
  Tags,
  YourCustomer,
  CustomFieldsCard,
} from '../cards';
import { Row, Col } from '../common';
import { useEventTypeEvaluationsContext } from '../context';
import { hasFraudSignalServiceConfigured, hasReturnedReasonCodesData, hasDataSourcesData } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { FraudSignalCard } from '../../FraudSignalCard';
import { useFetchedUserContext } from '~/helpers/hooks';

export const ExternalAccountCreatedOverview = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const { feature_flags: featureFlags } = useFetchedUserContext();
  const hideEmptyCardsEnabled = !!featureFlags?.['remove-empty-cards'];

  return (
    <Row>
      <Col>
        <ExternalAccount />
        <YourCustomer useExistingPiiOnly />
        <ImportedData />
        <OtherData />
      </Col>
      <Col>
        <OutcomeReasons />
        <Tags />
        <FraudSignalCard
          evaluationToken={evaluation.evaluation_token}
          hasFraudSignalService={hasFraudSignalServiceConfigured(evaluation)}
        />
        {shouldRenderCard(hasReturnedReasonCodesData(evaluation), hideEmptyCardsEnabled)
          && <ReasonCodes />}
        {shouldRenderCard(hasDataSourcesData(evaluation), hideEmptyCardsEnabled)
          && <DataSources />}
        <CustomFieldsCard />
      </Col>
    </Row>
  );
};
